import GallerySection from '../components/GallerySection.jsx';

export default function GalleryPage() {
  return <GallerySection titleTag="h1" />;
}
